import Vue from 'vue';
import store from '@/store';

// v-can, checks permissons against the current user
Vue.directive('can', {
  inserted(el, binding, vnode) {
    const { user } = store.getters;
    const removeChild = document.createComment(' ');

    if (user.is_admin) {
      return;
    }

    if (!user.permissions.includes(binding.value)) {
      el.parentNode.replaceChild(removeChild, el);
    }
  },
});
